import React, { useState, useEffect } from "react";
import Overlay from "../../../generic components/overlay/Overlay.js";
import FormikForm from "../../../generic components/form/form";
import { getInitialValues } from "../../../generic components/form/formUtils";
import { programModel, transformAgeAndDuration } from "./programData";
import ProgramsList from "../programs/programList/ProgramList";
import "../../../index.scss";
import routes from "../../../requests/routes";
import axios from "../../../requests/axios";
import classes from "../admin.module.css";

const AdminPrograms = () => {
  const [addProgram, setAddProgram] = useState(false);

  const initialValues = getInitialValues(programModel);

  const onSubmit = async (values, { setSubmitting, setValues }) => {
    values = transformAgeAndDuration(values);
    await axios.post(routes.createProgram, values);
    setSubmitting(false);
    setValues(initialValues);
    window.location.reload();
  };

  return (
    <div>
      <div className={classes.head}>
        <h2 className="adminTitle">Programs</h2>
      </div>
      <ProgramsList setModalOpen={() => setAddProgram(true)} />
      <Overlay
        open={addProgram}
        onClose={() => setAddProgram(false)}
        header="Add Program"
        width="75rem"
      >
        <FormikForm
          model={programModel}
          initialValues={initialValues}
          onSubmit={onSubmit}
          submitMsg="Create Program"
          orderByRows={true}
        />
      </Overlay>
    </div>
  );
};

export default AdminPrograms;
